// Menu mobile (templates/components/anima/menu-mobile.twig), sous 1 080 px : le bouton ouvre le
// panneau sous l'en-tête ; il se ferme au second clic, à Échap (le focus revient au bouton), au
// clic hors de l'en-tête, sur un lien choisi et au passage en bureau.

const DESKTOP = window.matchMedia('(min-width: 1080px)')

const init = () => {
  const root = document.querySelector('[data-anima-mnav]')
  const header = document.getElementById('header')
  if (!root || !header) {
    return
  }
  const btn = root.querySelector('.anima-mnav-btn')
  const panel = root.querySelector('.anima-mnav-panel')

  // Le panneau n'est pas `hidden` dans le balisage (repli sans JS) : fermé ici, puis montré.
  panel.hidden = true
  panel.dataset.animaPret = ''

  const toggle = (open) => {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false')
    panel.hidden = !open
    header.classList.toggle('has-mnav-open', open)
  }
  const isOpen = () => btn.getAttribute('aria-expanded') === 'true'

  btn.addEventListener('click', () => toggle(!isOpen()))
  panel.addEventListener('click', (e) => {
    if (e.target.closest('a')) {
      toggle(false)
    }
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      toggle(false)
      btn.focus()
    }
  })
  document.addEventListener('click', (e) => {
    if (isOpen() && !header.contains(e.target)) {
      toggle(false)
    }
  })
  DESKTOP.addEventListener('change', () => toggle(false))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
